export default {
  id: 78,
  title: 'Target #78 - Ukulele',
  url: 'https://cssbattle.dev/play/78',
  colors: ['#F3AC3C', '#998235', '#1A4341'],
  solution:
    '<a a><a b><a c><a d><a e><style>[c],[d],[e]{border-radius:9in}[a],[c],[e]{background:#1a4341}body{background:#f3ac3c}a{position:fixed}[a]{top:140;left:200;width:120;height:20}[b]{top:135;right:45;width:40;height:30;border-radius:10px;background:#998235}[c]{top:143;right:55;width:20;height:4;box-shadow:0 10px #1a4341}[d]{top:100;left:115;width:100;height:100;box-shadow:inset 0 0 0 25px #998235,inset 0 0 0 30px #f3ac3c,inset 0 0 0 50px #1a4341,-60px 0 0 10px #998235}[e]{top:130;left:85;width:10;height:40}</style>',
}
